// ============================================================
// musterFit - how densely the muster draws, as the roster grows
// (2026-10-22, plan muster; the canvas's Growth artboard).
//
// Four steps, each taken only when the one before stops fitting - by
// MEASURING, never by a count, since a screen's height and a roster's
// names decide it, not how many there are:
//   1. full chips (two lines)
//   2. compact chips (one line, the wounds as an underline)
//   3. the actor rail's summary shrinks to its avatar, name and bar
//   4. the acted fold into a stub and the column scrolls
// ============================================================

export type MusterStep = 1 | 2 | 3 | 4;

/** A pixel of slack: sub-pixel rounding between scrollHeight and clientHeight is not overflow. */
const SLACK_PX = 1;

/**
 * The step after `step`, given the list's measured `content` and `room` (scrollHeight and clientHeight, px): one
 * denser while it overflows, never past `max`. A column not laid out yet (no room) is left where it is.
 */
export function stepAfter(step: MusterStep, m: { content: number; room: number }, max: MusterStep): MusterStep {
  if (m.room <= 0 || m.content <= m.room + SLACK_PX || step >= max) return step;
  return (step + 1) as MusterStep;
}
